import React, {Component, Fragment} from 'react';
import * as hooks from "../../../../../utils/hooks";
import * as func from "../../../../../utils/functions";
import ReactPaginate from "react-paginate";
import {BASE_PATH} from "../../../../../wpconfig";
import {NavLink} from "react-router-dom";
import {objectToQueryString, pushUrl} from "../../../../../utils/functions";
import Loading from "../../../../etc/loading";
import MPSelf from "./mySelf"

class MyThesis extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isInit: false,
			param: {
				'current_page': 1,
				'record_per_page': 5,
				'ks': '',
				'sub_ks': '',
				'collabo_org': [],
				'cited_count': [],
				'resource_type': [],
				'publisher': [],
				'registered_db_name': [],
				'dept': [],
				'registered_db_year': [],
				'scholar': [],
				'author_count': [],
				'order_by': 'date',
				'order': 'desc',
				'my_library': true
			},
			records: [],
			totalRecords: 0,
			totalPage: 0,
			action: 'my_library/resources',
			selfSelectId : '',
			arrIndex : 0,
			showPopup : false,
			selfStatus : false,
		}

		this.showEditPopup = this.showEditPopup.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
	}

	componentDidMount() {
		this.getList();
	}

	componentWillUnmount() {
		this.setState = (state, callback) => {
			return;
		}
	}

	getList() {
		func.getData(this.state.action, this.state.param).then((response) => {
			this.setState({
				isInit: true,
			})
			let param = this.state.param;
			param.current_page

			this.setState({
				records: response.records,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
			})
		});
	}

	onUpdate(index, value, render) {
		const records = this.state.records;
		records[index].self_confirm = value;
		this.setState({records : records})
		if(render)
			this.forceUpdate();
	}

	showEditPopup (id, status, index) {
		if(status) {
			const p = {
				record_id : id,
				self_confirm : 'Y'
			}
			func.updateData('my_library/resource', p).then((response) => {
				const records = this.state.records
				records[index].self_confirm = 'Y'

				this.setState({
					showPopup : !this.state.showPopup,
					selfSelectId : id,
					selfStatus : status,
					arrIndex : index,
					records : records
				})
			});
		} else {
			this.setState({
				showPopup : !this.state.showPopup,
				selfSelectId : id,
				selfStatus : status,
				arrIndex : index
			})
		}
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.state.param;
		param['current_page'] = paged;

		func.getData(this.state.action, param).then((response) => {
			this.setState({
				param: param,
				records: response.records,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
			})
		});
	}

	render() {
		const records = this.state.records;
		const {isInit} = this.state;

		return (
			<div className="tab-data active">
				<div>
					{!isInit && <Loading/>}
					{isInit ?
					<div className="position-relative">
						<div className="line-list-group">
							{records.map((record, index) => {
								const no = this.state.totalRecords - ((this.state.param.current_page - 1) * this.state.param.record_per_page) - index;
								return (
									<div key={record.resource_id} className="document-list-item">
										<NavLink to={BASE_PATH + "resource/?record_id=" + record.resource_id}
										         className="item-subject">{record.resource_title}</NavLink>
										<div className="font-size-14 color-lightblack">
											{record.scholar && record.scholar.map((item, index) => {
												return(
													<Fragment key={index}>
														<strong className="color-lightblue"> {item.author_name}</strong>
														<span className="color-lightblue">({item.dept_name ? item.dept_name : ''})
															{record.scholar.length - 1 > index && ','}
														</span>
													</Fragment>
												)
											})}
										</div>
										<div className="item-info">
											{record.issn &&
											<div className="info-cell"><strong>ISSN</strong> {record.issn}</div>
											}
											{record.publisher &&
											<div className="info-cell"><strong>Publisher</strong> {record.publisher}</div>
											}
											<div className="info-cell">{record.publish_year ? record.publish_year + ',' : ''} {record.volume ? record.volume : ''}{record.issue ? '(' + record.issue + ')' : ''}
												{(record.start_page && record.end_page) && ' P.'}{record.start_page}{record.end_page ? '~' : ''}{record.end_page ? record.end_page : record.end_page}
											</div>
										</div>
										{(record.journal_ranking && record.journal_ranking.length > 0 || record.resource_count > 0) &&
										<div className="item-options">
											<div className="options-cell">
												<div className="badge-group">
													<div className="badge-group-inner">
														{record.journal_ranking && record.journal_ranking.map((item, index) => {
															let className = 'badge bg-lightpurple';
															if (!item.percent || !item.name)
																return;
															// item.name = item.name.toUpperCase()
															if (item.name === 'KCI')
																className = 'badge bg-lightgreen';
															else if (item.name === 'Scopus')
																className = 'badge bg-lightorange';
															return (
																<div key={index}
																     className={className}>{item.name} (Top {item.percent}%)</div>
															)
														})}
														{record.registered_db && record.registered_db.map((item, index) => {
															let className = 'badge bg-lightpurple';
															// item = item.toUpperCase()
															if (item.includes('KCI'))
																className = 'badge bg-lightgreen';
															else if (item.includes('Scopus'))
																className = 'badge bg-lightorange';
															else if (item.includes('Nature Index'))
																className = 'badge bg-skyblue';
															return (
																<div key={index} className={className}>{item}</div>
															)
														})}
													</div>
												</div>
											</div>
										</div>
										}
										{!record.self_confirm &&
										<div className="d-flex align-items-center justify-content-end w-100 mt-4">
											<div className="icon icon-size-24 icon-question-blue mr-2"/>
											<div className="font-size-14 color-black mr-3">내 논문이고 공동자의 정보가 정확한가요?</div>
											<button type="button" className="btn btn-skyblue w-px-80 mr-2"
											        onClick={() => this.showEditPopup(record.resource_id, true, index)}>예
											</button>
											<button type="button" className="btn btn-skyblue w-px-80"
											        onClick={() => this.showEditPopup(record.resource_id, false, index)}>아니오
											</button>
										</div>
										}
									</div>
								)
							})}
						</div>
						{this.state.totalPage > 1 &&
						<div className="mt-4">
							<div>
								<div className="paging-wrap">
									<ReactPaginate
										forcePage={Number(this.state.param.current_page) - 1}
										pageCount={this.state.totalPage}
										marginPagesDisplayed={2}
										pageRangeDisplayed={10}
										onPageChange={this.handlePageClick}
										containerClassName={'pagination'}
										activeClassName={'active'}
										pageClassName={'page-item'}
										pageLinkClassName={'page-link'}
										previousClassName={'page-item page-item-prev'}
										previousLinkClassName={'page-link'}
										nextClassName={'page-item page-item-next'}
										nextLinkClassName={'page-link'}
									/>
								</div>
							</div>
						</div>
						}
					</div>
					: '' }
				</div>
				{this.state.showPopup &&
				<MPSelf
					arrIndex={this.state.arrIndex}
					onUpdate={this.onUpdate}
					selfSelectId={this.state.selfSelectId}
					selfStatus={this.state.selfStatus}
					closePopup={this.showEditPopup}
				/>
				}
			</div>
		);
	}
};

export default MyThesis;
